import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import { Link } from "react-router-dom";
import StudentSidebar from "../common/studentSidebar";
import ProfileCard from "../common/profileCard";
import CourseCard from "../common/courseCard";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import { useAuth } from "../../../core/hooks/useAuth";
import { Pagination } from "../../../core/common/ults/pagination";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";

const StudentCourse = () => {
  const { moodleUser } = useAuth();
  const { enrolledCourses, isEnrolledCoursesLoading, allCourses, isAllCourses, typeEnrol, isTypeEnrol } = useHandleCourses(
    moodleUser?.id
  );
  const { courseDetails, isCourseDetailsLoading } = useHandleCourses(allCourses?.id)
  const { t } = useTranslation();
// fake progress percent
  const fakePercents = [20, 50, 80, 35, 60, 90, 10, 75, 40, 55];

  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem('activeTab');
    return savedTab || 'enroll-courses';
  });

  useEffect(() => {
    sessionStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  // Hàm lọc các khóa học chưa đăng ký
  const getUnenrolledCourses = () => {
    if (!allCourses || !enrolledCourses) return [];
    const enrolledCourseIds = enrolledCourses.map((course: { id: number }) => course.id);
    return allCourses
      .filter((course: { id: number }) => !enrolledCourseIds.includes(course.id))
      .filter((course: { id: number }) => course.id !== 1);
  };

  // Kiểm tra xem một khóa học có phải là khóa học chưa đăng ký không
  const isUnenrolledCourse = (courseId: number) => {
    if (!enrolledCourses) return false;
    return !enrolledCourses.some((course: { id: number }) => course.id === courseId);
  };

  const handleCourseClick = (course: any) => {
    // Xử lý logic khi click vào khóa học nếu cần
  };

  // Tính toán dữ liệu hiển thị
  const startIndex = (currentPage - 1) * itemsPerPage;
  const filteredAllCourses = allCourses?.filter((course: { id: number }) => course.id !== 1);
  const currentAllCourses = filteredAllCourses?.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const currentCourses = enrolledCourses?.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const currentActiveCourses = enrolledCourses?.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    setCurrentPage(1); // Reset về trang 1 khi chuyển tab
  };

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("headerMenu.courses")} />
              <div className="page-title d-flex flex-wrap gap-3 align-items-center justify-content-between">
                <h5>{t("headerMenu.courses")}</h5>
                <div className="tab-list">
                  <ul className="nav mb-0 gap-2" role="tablist">
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        className={activeTab === 'all-courses' ? 'active' : ''}
                        data-bs-toggle="tab"
                        data-bs-target="#all-courses"
                        aria-selected="true"
                        role="tab"
                        onClick={() => handleTabChange('all-courses')}
                      >
                        {t("courses.allCourses")} ({filteredAllCourses?.length})
                      </Link>
                    </li>
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        className={activeTab === 'unenrolled-courses' ? 'active' : ''}
                        data-bs-toggle="tab"
                        data-bs-target="#unenrolled-courses"
                        aria-selected="false"
                        role="tab"
                        onClick={() => handleTabChange('unenrolled-courses')}
                      >
                        {t("courses.unenrolledCourses")} ({getUnenrolledCourses()?.length})
                      </Link>
                    </li>
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        className={activeTab === 'enroll-courses' ? 'active' : ''}
                        data-bs-toggle="tab"
                        data-bs-target="#enroll-courses"
                        aria-selected="true"
                        role="tab"
                        onClick={() => handleTabChange('enroll-courses')}
                      >
                        {t("courses.enrolled")} ({enrolledCourses?.length})
                      </Link>
                    </li>
                    
                  </ul>
                </div>
              </div>
              <div className="tab-content">
                <div
                  className={`tab-pane fade ${activeTab === 'all-courses' ? 'active show' : ''}`}
                  id="all-courses"
                  role="tabpanel"
                >
                  <div className="mb-3 d-flex justify-content-end">
                    {/* Xóa checkbox showUnenrolledOnly */}
                  </div>
                  <div className="row">
                    {isEnrolledCoursesLoading ? (
                      <Skeleton height={200} className="mb-3" />
                    ) : (
                      <>
                        {/* Xóa logic hiển thị thông báo 'Bạn đã đăng ký toàn bộ khóa học' */}
                        {currentAllCourses?.map((course: any, index: any) => (
                          <div key={index} className="col-xl-4 col-md-6">
                            <CourseCard 
                                course={course} 
                                index={index} 
                                isUnenrolled={isUnenrolledCourse(course.id)}
                                onCourseClick={handleCourseClick}
                                showEnrolledCount={false}
                              />
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  <div className="row align-items-center mt-2">
                    <Pagination
                      totalItems={filteredAllCourses?.length || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={(page: number) => setCurrentPage(page)}
                    />
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${activeTab === 'enroll-courses' ? 'active show' : ''}`}
                  id="enroll-courses"
                  role="tabpanel"
                >
                  <div className="row">
                    {isEnrolledCoursesLoading ? (
                      <Skeleton height={200} className="mb-3" />
                    ) : (
                      <>
                        {currentCourses?.map((course: any, index: any) => {
                          return (
                            <div key={index} className="col-xl-4 col-md-6">
                              <CourseCard 
                                course={course} 
                                index={index} 
                                showEnrolledCount={true}
                                progressPercent={fakePercents[startIndex + index] || 0}
                              />
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                  <div className="row align-items-center mt-2">
                    <Pagination
                      totalItems={enrolledCourses?.length || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={(page: number) => setCurrentPage(page)}
                    />
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${activeTab === 'unenrolled-courses' ? 'active show' : ''}`}
                  id="unenrolled-courses"
                  role="tabpanel"
                >
                  <div className="row">
                    {isEnrolledCoursesLoading ? (
                      <Skeleton height={200} className="mb-3" />
                    ) : (
                      <>
                        {getUnenrolledCourses()?.length === 0 ? (
                          <div className="col-12 text-center py-4">
                            <p className="mb-0">{t("courses.youAreEnrolledInAllCourses")}</p>
                          </div>
                        ) : (
                          getUnenrolledCourses()?.slice(
                            startIndex,
                            startIndex + itemsPerPage
                          ).map((course: any, index: any) => (
                            <div key={index} className="col-xl-4 col-md-6">
                              <CourseCard 
                                course={course} 
                                index={index} 
                                isUnenrolled={isUnenrolledCourse(course.id)}
                                onCourseClick={handleCourseClick}
                                showEnrolledCount={false}
                              />
                            </div>
                          ))
                        )}
                      </>
                    )}
                  </div>
                  <div className="row align-items-center mt-2">
                    <Pagination
                      totalItems={getUnenrolledCourses()?.length || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={(page: number) => setCurrentPage(page)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentCourse;
